/**
 * 說明 : 指派條件與後端API調用的非同步行為
 */
import {createAsyncThunk} from '@reduxjs/toolkit';

import BaseAPI from './BaseAPI';

// 新增指派條件資訊
export const addCondition = createAsyncThunk(
  'condition/addCondition',
  async (condition, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.postWithAuth('/condition', condition, token);
      return data;
    } catch (err) {
      console.error('add department error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 修改指派條件資訊
export const editCondition = createAsyncThunk(
  'condition/editCondition',
  async (condition, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.putWithAuth('/condition', condition, token);
      return data;
    } catch (err) {
      console.error('edit department error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 修改部門狀態
export const editConditionStatus = createAsyncThunk(
  'condition/editConditionStatus',
  async ({conditionCodes, flgStatus}, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.putWithAuth(
        '/condition/status',
        {conditionCodes, flgStatus},
        token,
      );
      return data;
    } catch (err) {
      console.error('edit department error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 取得指派條件清單列表
export const fetchConditionList = createAsyncThunk(
  'condition/fetchConditionList',
  async ({}, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.getWithAuth('/condition', {}, token);
      return data;
    } catch (err) {
      console.log('fetch condition list error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 取得有效的部門名稱選單
export const fetchConditionSelection = createAsyncThunk(
  'condition/fetchConditionSelection',
  async (conditionCode, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.getWithAuth(
        '/selection/condition',
        {conditionCode},
        token,
      );
      return data;
    } catch (err) {
      console.error('fetch condition selection error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);
